import {ISymbolStateConfig, SymbolStateTransition} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineLite, TweenLite} from "gsap";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {HorribleHeroesGameConfig} from "../HorribleHeroesGameConfig";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TrailReelSymbol} from "./TrailReelSymbol";

export interface ISaberAnimation {
    topSaber: TimelineSprite;
    rightSaber: TimelineSprite;
    leftSaber: TimelineSprite;
    bottomSaber: TimelineSprite;
}

export class HorribleHerosXSymbol extends TrailReelSymbol {
    protected _symTop: PIXI.Sprite;
    protected _symBottom: PIXI.Sprite;
    protected _symLeft: PIXI.Sprite;
    protected _symRight: PIXI.Sprite;
    private _isMayhemMode: boolean = false;
    private _anchorY: number = 0.5;
    private _multiplier: PIXI.Sprite;
    private _saberAnimation: ISaberAnimation;
    private _saberContainer: PIXI.Sprite;
    private _expandAnim: TimelineLite;

    public createSprite(texture: string, sprite: PIXI.Sprite): PIXI.Sprite {
        const temp: PIXI.Sprite = new PIXI.Sprite();
        temp.position.set(0, 0);
        temp.anchor.set(0.5, 0.5);
        temp.texture = GameResources.getTextures(texture)[0];
        temp.scale.set(sprite.scale.x, sprite.scale.y);
        temp.x = sprite.x;
        temp.y = sprite.y;
        temp.alpha = 0;
        temp.name = sprite.name + "_blended";
        temp.blendMode = PIXI.BLEND_MODES.ADD;
        if (temp.name) {
            this.addChildAt(temp, this.getChildIndex(sprite) + 1);
        }

        return temp;
    }

    public playSaberAnimation(mSize: number, symHeight: number): void {
        // move the current reel to the top of all reels.
        const reelView: PIXI.DisplayObject = this.parent;

        if (reelView.transform && reelView.parent.transform) {
            reelView.parent.addChild(reelView);
            const index = this.parent.getChildIndex(this);

            this.parent.addChildAt(this._saberContainer, index);
            this._saberContainer.x = this.x;
            this._saberContainer.y = this.y - (symHeight + 3);
        }
        if (mSize === 3) {
            this._saberContainer.y -= 40;
            this._saberAnimation.bottomSaber.y = 230;
            this._saberAnimation.leftSaber.y = 90;
            this._saberAnimation.rightSaber.y = 90;

            this._saberAnimation.leftSaber.scale.set(2, 1);
            this._saberAnimation.rightSaber.scale.set(2, 1);
            this._saberAnimation.topSaber.y = -40;
        } else {
            this._saberAnimation.bottomSaber.y = 176;
            this._saberAnimation.leftSaber.y = 65;
            this._saberAnimation.rightSaber.y = 65;
            this._saberAnimation.leftSaber.scale.set(1.7, 1);
            this._saberAnimation.rightSaber.scale.set(1.7, 1);
            this._saberAnimation.topSaber.y = -55;
        }
        this._saberContainer.alpha = 0;
        TweenLite.to(this._saberContainer, 0.1, {alpha: 1});
        this._saberAnimation.topSaber.playLoop();
        this._saberAnimation.bottomSaber.playLoop();
        this._saberAnimation.leftSaber.playLoop();
        this._saberAnimation.rightSaber.playLoop();
    }

    public hideSaberAnimation(isAbort?: boolean): void {
        this._saberContainer.alpha = 1;
        if (isAbort) {
            this.removeSaberanimation();
        } else {
            TweenLite.to(this._saberContainer, 0.1, {
                alpha: 0, onComplete: () => {
                    this.removeSaberanimation();
                }
            });
        }
    }

    public setMayhemMode(isMayhem: boolean): void {
        this._isMayhemMode = isMayhem;
        if (this._isMayhemMode) {
            if (this._multiplier) this._multiplier.visible = false;
        }
    }

    public quickExpansion(timeScale?: number): void {
        //#227  quick xpansion on infecedsyms
        if (this._expandAnim && timeScale) {
            this._expandAnim.timeScale(1.5);
            return;
        }
        if (this._expandAnim && this._expandAnim.progress() < 1) {
            this._expandAnim.totalProgress(1);
        }
    }

    public patchMultiplier(multiplier: number): void {
        if (this._isMayhemMode) {
            return;
        }
        this._multiplier.anchor.set(0.5);
        this._multiplier.texture = GameResources.getTextures(`Multiplier${multiplier}`)[0];
        this.addChild(this._multiplier);
        this._multiplier.visible = true;
        this._multiplier.x = 17;
        this._multiplier.y = -4;
        if (multiplier == 3) {
            this._symTop.y = -this.symHeight / 2 + this._symTop.height / 2;
        }
    }

    public playExpandingAnimation(symHeight: number, mSize: number, shiftY: number, symId: number, previousHeight: number, lastSym?: number): void {
        if (!lastSym) {
            lastSym = 3;
        }
        const duration = 0.2;
        if (this._expandAnim && this._expandAnim.progress() === 1) {
            this._expandAnim.progress(0);
        }
        this._expandAnim = new TimelineLite({
            onComplete: () => {
                this._expandAnim.pause();
                this._expandAnim.kill();
                this._expandAnim.clear();
            }
        });
        symHeight = symHeight * mSize;

        this.parent.addChild(this);

        let sideShiftY: number = 22;
        if (mSize == 3) {
            sideShiftY = 74;
        }
        if (symId == lastSym) {
            sideShiftY = -sideShiftY;
        }
        if (!this._isMayhemMode) {
            this.setUpMultiplier(mSize);
        }

        this._bg.scale.set(1, symHeight / previousHeight);
        const bg = this.createSprite("X_bg", this._bg);
        const left = this.createSprite("X_left", this._symLeft);
        const right = this.createSprite("X_left", this._symRight);
        const top = this.createSprite("X_top", this._symTop);
        const bottom = this.createSprite("X_top", this._symBottom);
        const symImage = this.createSprite("X", this._symImage);
        this._expandAnim.to(this._symMask!.scale, duration, {y: symHeight / previousHeight}, 0);
        this._expandAnim.to(bg!, duration, {alpha: 1}, 0);
        this._expandAnim.to(left!, duration, {alpha: 1}, 0);
        this._expandAnim.to(right!, duration, {alpha: 1}, 0);
        this._expandAnim.to(top, duration, {alpha: 1}, 0);
        this._expandAnim.to(bottom, duration, {alpha: 1}, 0);

        this._expandAnim.to(left!, duration, {y: sideShiftY}, 0);
        this._expandAnim.to(right!, duration, {y: sideShiftY}, 0);
        this._expandAnim.to(symImage!, duration, {y: -shiftY}, 0);
        this._expandAnim.to(bg!, duration, {y: -shiftY}, 0);
        this.symTopAndBottom(shiftY, sideShiftY);
        if (symId == 0) {
            this._symTop.y = (-(previousHeight) / 2) + this._symTop.height / 2;
            this._expandAnim.to(this._symBottom!, duration, {y: (symHeight) / 2 - this._symTop.height / 2 - shiftY}, 0);
            this._expandAnim.to(bottom!, duration, {y: symHeight / 2 - this._symTop.height / 2 - shiftY}, 0);
        } else if (symId == lastSym) {
            this._expandAnim.to(this._symTop!, duration, {y: -symHeight / 2 + this._symTop.height / 2 - shiftY}, 0);
            this._expandAnim.to(top!, duration, {y: -symHeight / 2 + this._symTop.height / 2 - shiftY}, 0);
        } else {
            //middleSymbol
            sideShiftY = shiftY;
            //#570
            this._expandAnim.to(this._symTop!, duration, {y: (-(symHeight) / 2 + this._symTop.height / 2) - shiftY}, 0);
            this._expandAnim.to(top!, duration, {y: (-(symHeight) / 2 + this._symTop.height / 2) - shiftY}, 0);
            this._expandAnim.to(this._symBottom!, duration, {y: (symHeight) / 2 - this._symTop.height / 2 - shiftY}, 0);
            this._expandAnim.to(bottom!, duration, {y: (symHeight) / 2 - this._symTop.height / 2 - shiftY}, 0);
            this._expandAnim.to(left!, duration, {y: -sideShiftY}, 0);
            this._expandAnim.to(right!, duration, {y: -sideShiftY}, 0);
            this._expandAnim.to(this._symLeft!, duration, {y: -sideShiftY}, 0);
            this._expandAnim.to(this._symRight!, duration, {y: -sideShiftY}, 0);
        }
    }

    // #268
    public playExtraLandingAnimations(): void {
        const antiLoop: TimelineSprite = new TimelineSprite(GameResources.getTextures("antiLoop"), 43),
            antiStrike: TimelineSprite = new TimelineSprite(GameResources.getTextures("antiStrike"), 45);

        antiLoop.blendMode = PIXI.BLEND_MODES.ADD;
        antiLoop.anchor.set(0.5);
        antiLoop.position.set(this.parent.parent.x + this.x, 280);
        antiLoop.alpha = 0;
        TweenLite.to(antiLoop, 0.14, {alpha: 1});
        TweenLite.to(antiLoop, 0.34, {alpha: 0, delay: 0.23});
        this.parent.addChildAt(antiLoop, this.parent.getChildIndex(this));
        antiLoop.getAnimationAutoShowHide(true, true, undefined, undefined, () => antiLoop.parent.removeChild(antiLoop));

        antiStrike.anchor.set(0.5);
        antiStrike.scale.set(0.8);
        antiStrike.blendMode = PIXI.BLEND_MODES.ADD;
        antiStrike.position.set(this.parent.x + this.x, 420);
        StageManager.getLayer(HorribleHeroesGameConfig.instance.LAYERS.ANTI_STRIKE.name).addChild(antiStrike);
        antiStrike.getAnimationAutoShowHide(true, true, undefined, undefined, () => antiStrike.parent.removeChild(antiStrike));
    }

    public updateFrame(symHeight: number): void {
        if (this._symTop) {
            this._symTop.y = -symHeight / 2 + this._symTop.height / 2;
            this._symBottom.y = symHeight / 2 - this._symTop.height / 2;
            this._symLeft.x = -this.symWidth / 2 + this._symLeft.width / 2;
            this._symRight.x = this.symWidth / 2 - this._symRight.width / 2;
        }
    }

    public updateBackground(symHeight: number, greenBg?: boolean, multiplier?: number, isAbort?: boolean): void {
        super.updateBackground(symHeight);
        if (greenBg) {
            this._bg.texture = GameResources.getTextures("X_Gbg")[0];
            if (multiplier) {
                if (!this._isMayhemMode) {
                    this._multiplier.texture = GameResources.getTextures(`Multiplier${multiplier}`)[0];
                    this.addChild(this._multiplier);
                    this._multiplier.visible = true;
                    this._multiplier.x = 17;
                    this._multiplier.y = -4;
                    this.scaleDownAnimation(isAbort);
                }
            }
            this._symTop.y = -this.symHeight / 2 + this._symTop.height / 2;
        }
        this._anchorY = 0.5;
        for (let stateName in this._stateAnimations) {
            const state = this._stateAnimations[stateName];
            if (state != null) {
                state.anchor.y = this._anchorY;
                this._symImage.anchor.y = this._anchorY;
                this.fitToSize(state, symHeight);
            }
        }
    }

    public scaleDownAnimation(isAbort?: boolean): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        this!.scale.set(1.5);
        this!.alpha = 0.3;
        if (!isAbort) {
            tl.to(this!.scale, 0.2, {x: 1, y: 1}, 0);
            tl.to(this!, 0.2, {alpha: 1}, 0);
        } else {
            this!.scale.set(1);
            this.alpha = 1;
        }
        return tl;
    }

    public drawSymMask(): void {
        this._symMask = new PIXI.Graphics();
        this._symMask.beginFill(0xFFFFFF, 0.5);
        this._symMask.drawRect(-GameConfig.instance.SYMBOL_WIDTH / 2, -this.symHeight / 2, GameConfig.instance.SYMBOL_WIDTH, this.symHeight);
        this.addChild(this._symMask);
        this.mask = this._symMask;
    }

    protected initAnimations(): void {
        super.initAnimations();
        //#395
        this.name = "X";
        this._bg.texture = GameResources.getTextures("X_bg")[0];
        this._bg.name = "X_bg";
        if (!this._symRight) {
            this._symLeft = this.createEmptySprite("X_left");
            this._symRight = this.createEmptySprite("X_left", 0.5, "X_right");
            this._symRight.scale.x = -1;
            this._symLeft.x = -this.symWidth / 2 + this._symLeft.width / 2;
            this._symRight.x = this.symWidth / 2 - this._symRight.width / 2;
        }
        if (!this._symTop) {
            this._symTop = this.createEmptySprite("X_top", 0);
            this._symTop.y = -this.symHeight / 2 + this._symTop.height / 2;
        }
        if (!this._symBottom) {
            this._symBottom = this.createEmptySprite("X_top", 1, "X_bottom");
            this._symBottom.y = this.symHeight / 2 - this._symBottom.height / 2;
            this._symBottom.scale.y = -1;
        }
        if (!this._multiplier && !this._isMayhemMode) {
            this._multiplier = this.createEmptySprite("Multiplier2");
            this._multiplier.scale.set(1);
            this._multiplier.visible = false;
            this._multiplier.x = 17;
            this._multiplier.y = -4;
        }
        this._saberContainer = new PIXI.Sprite();
        this._saberAnimation = this.createSaberAnimation();
        this._saberContainer.alpha = 0;
    }

    protected addNewStateAnimation(timeline: TimelineLite, newState: SymbolStateTransition, stateAnimation: TimelineSprite, delay: number): void {
        super.addNewStateAnimation(timeline, newState, stateAnimation, delay);
        if (newState.state.keyword === HorribleHeroesGameConfig.instance.SYMBOL_STATES.normal.keyword) {
            timeline.add(() => {
                this.toggleVisiblity(1, delay)
            }, delay)
        }
        if (newState.state.keyword === HorribleHeroesGameConfig.instance.SYMBOL_STATES.spin.keyword) {
            timeline.add(() => {
                this.toggleVisiblity(0, delay)
            }, delay)
        }
        if (newState.state.keyword === HorribleHeroesGameConfig.instance.SYMBOL_STATES.mayhem.keyword) {
            timeline.add(() => {
                this.toggleVisiblity(0, delay)
            }, delay)
        }
    }

    protected reset(remove: boolean): void {
        this.resetAllAnim(remove);
        super.reset(remove);
    }

    protected initState(stateConfig: ISymbolStateConfig): boolean {
        if (super.initState(stateConfig)) {
            if (this.symHeight > 147) {
                this._anchorY = 0.25;
            } else {
                this._anchorY = 0.25;
            }
            if (this._symLeft) {
                this.addChild(this._symLeft);
            }

            if (this._symRight) {
                this.addChild(this._symRight);
            }
            if (this._symBottom) {
                this.addChild(this._symBottom);
            }

            if (this._symTop) {
                this.addChild(this._symTop);
            }
            if (this.symHeight < 149) {
                this._stateAnimations[stateConfig.keyword]!.anchor.set(0.5);
            } else {
                this._stateAnimations[stateConfig.keyword]!.anchor.y = this._anchorY;
            }

            if (this._multiplier) {
                this.addChild(this._multiplier);
            }
            if (this._symMask) {
                this.addChild(this._symMask);
                this.mask = this._symMask;
            }
            return true;
        }

        return false;
    }

    protected fitToSize(state: TimelineSprite, symHeight?: number): void {
        if (!symHeight) {
            symHeight = this._symHeight!;
        }
        if (this.symName.indexOf("*") > -1) {
            state.y = 0;
            this._symImage.y = 0;
        } else {
            if (HorribleHeroesGameConfig.instance.HIGHMSYMS.indexOf(this.symName) > -1) {
                state.y = -(symHeight * 0.1);
                this._symImage.y = -(symHeight * 0.1);
            } else {
                state.y = 0;
                this._symImage.y = 0;
            }
        }
    }

    protected createTrailOverlay(): PIXI.Sprite {
        const fire: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("XTrail")[0]);
        fire.anchor.set(0.5);
        fire.scale.set(1);
        fire.blendMode = PIXI.BLEND_MODES.ADD;
        fire.name = "XTrail";
        return fire;
    }

    private createSaberAnimation(): ISaberAnimation {
        const glowBottom = this.createPotentialGlowFrame([1, 1], [0, 176], "x_saber", this._saberContainer, PIXI.BLEND_MODES.ADD);
        const glowTop = this.createPotentialGlowFrame([1, 1], [0, -40], "x_saber", this._saberContainer, PIXI.BLEND_MODES.ADD);
        const glowLeft = this.createPotentialGlowFrame([1, 1], [-65, 60], "x_saber", this._saberContainer, PIXI.BLEND_MODES.ADD);
        const glowRight = this.createPotentialGlowFrame([1, 1], [65, 60], "x_saber", this._saberContainer, PIXI.BLEND_MODES.ADD);

        glowRight.rotation = 1.57;
        glowLeft.rotation = 1.57;

        return {
            topSaber: glowTop,
            leftSaber: glowLeft,
            rightSaber: glowRight,
            bottomSaber: glowBottom
        };
    }

    private removeSaberanimation(): void {
        if (!this._saberContainer) {
            return;
        }
        this._saberContainer.alpha = 0;
        this._saberAnimation.bottomSaber.stopLoop();
        this._saberAnimation.leftSaber.stopLoop();
        this._saberAnimation.rightSaber.stopLoop();
        this._saberAnimation.topSaber.stopLoop();
        TweenLite.killTweensOf(this._saberContainer);
        const reelView: PIXI.DisplayObject = this.parent;
        if (reelView && reelView.transform && reelView.parent.transform) {
            this.parent.removeChild(this._saberContainer);
            if (this._saberContainer.parent === this.parent) {
                this.parent.removeChild(this._saberContainer);
            }
        }
    }

    private createPotentialGlowFrame(scale: number[], position: number[], textureName: string, container: PIXI.Sprite, blendMode: PIXI.BLEND_MODES): TimelineSprite {
        const potentialGlowFrame = new TimelineSprite(GameResources.getTextures(textureName));
        potentialGlowFrame.anchor.set(0.5, 0.5);
        potentialGlowFrame.scale.set(scale[0], scale[1]);
        potentialGlowFrame.position.set(position[0], position[1]);
        potentialGlowFrame.show();
        potentialGlowFrame.blendMode = blendMode;
        container.addChild(potentialGlowFrame);
        return potentialGlowFrame;
    }

    private setUpMultiplier(mSize: number): void {
        this._multiplier.anchor.set(0.5);
        this._multiplier.alpha = 1;
        this._multiplier.texture = GameResources.getTextures(`Multiplier${mSize}`)[0];
        this.addChild(this._multiplier);
        this._multiplier.visible = true;
        this._multiplier.x = 17;
        this._multiplier.y = -4;
    }

    private symTopAndBottom(shiftY: number, sideShiftY: number): void {
        this._expandAnim.to(this._bg!, 0.2, {y: -shiftY}, 0);
        this._expandAnim.to(this._symMask!, 0.2, {y: -shiftY}, 0);
        this._expandAnim.to(this._multiplier!, 0.2, {y: -4 - shiftY}, 0);
        this._expandAnim.to(this._symLeft!, 0.2, {y: sideShiftY - 4}, 0);
        this._expandAnim.to(this._symRight!, 0.2, {y: sideShiftY - 4}, 0);
        this._expandAnim.to(this._symImage!, 0.2, {y: -shiftY}, 0);
    }

    private toggleVisiblity(alphaV: number, delay: number): void {
        TweenLite.to(this._symTop, delay, {alpha: alphaV});
        TweenLite.to(this._symLeft, delay, {alpha: alphaV});
        TweenLite.to(this._symBottom, delay, {alpha: alphaV});
        TweenLite.to(this._symRight, delay, {alpha: alphaV});
    }

    private resetAllAnim(remove: boolean): void {
        // #247
        if (this._expandAnim && remove) {
            this._expandAnim.pause();
            this._expandAnim.kill();
            this._expandAnim.clear();
        }

        this.removeSaberanimation();
    }
}